import { concat, hash } from '@ember/helper';
import Component from '@glimmer/component';

import { t } from 'ember-intl';

import { CircularProgress } from 'umg-ember-backend/components/ui/circular-progress';
import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const tScope = 'record_detail.forms.a11y_report.';
const bem = getBem(styles);

export class Score extends Component {
  // Getter and setter
  get scoreName() {
    switch (true) {
      case this.args.score < 50:
        return 'bad';
      case this.args.score < 100:
        return 'ok';
      default:
        return 'good';
    }
  }

  // Template
  <template>
    <div class={{bem (hash color=this.scoreName)}}>
      <CircularProgress
        @progress={{@score}}
        @thickness='5'
        class={{bem 'progress'}}
      />
      <div class={{bem 'value'}}>
        <div class={{bem 'number'}}>{{@score}}%</div>
        <div class={{bem 'label'}}>{{t (concat tScope 'score')}}</div>
      </div>
    </div>
    <div class={{bem 'practices'}}></div>
  </template>
}
